import { useCabinBookingCalendar } from '../../Hooks/Features/CabinBooking/useCabinBookingCalendar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { dateConvert } from '../../utils/Helper';
import { Dialog } from 'primereact/dialog';
import CabinBookingForm from './CabinBookingForm';
import { CellSpanModule, ModuleRegistry, ClientSideRowModelModule, RowApiModule, ValidationModule, CellStyleModule, RowStyleModule } from "ag-grid-community";
import { SkeletonDataTable } from '../Loader/Loader';
import { AgGridReact } from 'ag-grid-react';

ModuleRegistry.registerModules([CellSpanModule, ClientSideRowModelModule, RowApiModule, ValidationModule, CellStyleModule, RowStyleModule, ...[],]);

const CabinBookingCalendar = ({ cabinList, callApi }) => {

    const { date, handleDateChange, coldef, rowData, handleCellClicked, showBooking, setShowBooking, booking, setBooking, view, setView, weekColDef, weekRowData, week, shiftTime, getCabinBookingDetails, formSlot, loader, editData, setEditData } = useCabinBookingCalendar({ cabinList, callApi });

    const customNoRowsTemplate = () => {
        return (
            <div className='text-danger'>{view === "week" ? "No Shift found for this week!" : "No Shift found for this date!"}</div>
        )
    }

    return (
        <div>
            <div className='d-flex justify-content-between'>
                <div className="d-flex gap-2 align-items-center">
                    <div>
                        <button className="btn-primary rounded-start" onClick={() => handleDateChange(-1)}><FontAwesomeIcon icon="fa-solid fa-angle-left" /></button>
                        <button className="btn-primary rounded-end" onClick={() => handleDateChange(1)}><FontAwesomeIcon icon="fa-solid fa-angle-right" /></button>
                    </div>
                    <button className="button btn-primary rounded" onClick={() => (handleDateChange(0))} disabled={new Date(date) === new Date()}>{view === "day" ? "Today" : "Current Week"}</button>
                </div>
                <div className='fw-bold fs-4'>
                    {view === "day" ? dateConvert(date, "day-fullmonth-year") : `${dateConvert(week?.start, "day-month-year")} - ${dateConvert(week?.end, "day-month-year")}`}
                </div>
                <div>
                    <button className={`btn-primary rounded-start cabin-calendar-view-btn ${view === "day" ? "active" : ""}`} onClick={() => setView("day")}>Day</button>
                    <button className={`btn-primary rounded-end cabin-calendar-view-btn ${view === "week" ? "active" : ""}`} onClick={() => setView("week")}>Week</button>
                </div>
            </div>
            <div className='ag-theme-alpine mt-2 cabin-booking-grid' style={{ height: "82vh" }}>
                {loader ? <SkeletonDataTable numSkeletons={20}/> :
                    <AgGridReact columnDefs={view === "week" ? weekColDef : coldef} rowData={view === "week" ? weekRowData : rowData} headerHeight={30} onCellClicked={handleCellClicked} enableCellSpan={true} theme="legacy" rowBuffer={50} rowClassRules={view === "week" ? {
                        'last-group-row': (params) => {
                            const thisDay = params.data?.week_days;
                            const thisIndex = params.node?.rowIndex;
                            const nextRow = params.api.getDisplayedRowAtIndex(thisIndex + 1);
                            return !nextRow || nextRow?.data?.week_days !== thisDay;
                        }
                    } : {}} noRowsOverlayComponent={customNoRowsTemplate} />
                }
            </div>

            <Dialog visible={showBooking} onHide={() => { setShowBooking(false); setBooking({}); setEditData({}); }} draggable={false} className='modal-large' header={`Book ${booking?.columnData?.name || ""} - ${dateConvert(booking?.data?.date, "day-fullmonth-year") || ""}`}>
                <CabinBookingForm shiftTime={shiftTime} selectedCabin={{ cabin_id: booking?.columnData?.cabin_id, field: booking?.columnData?.field }} selectedDate={view === "day" ? date : booking?.data?.date} closePopup={() => { setShowBooking(false); setBooking({}); setEditData({}); }} callApi={getCabinBookingDetails} displaySlot={formSlot} editData={editData} gridData={view === "week" ? weekRowData : rowData}/>
            </Dialog>
        </div>
    )
}

export default CabinBookingCalendar